import React, { useState } from "react";
import "./AllFAQs.scss";
import { AiFillPlusCircle } from "react-icons/ai";
import Fade from "react-reveal/Fade";

const AllFAQs = () => {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  
  const handlePlusToggle = () => {
    setShow(!show);
  };
  const handlePlusToggle2 = () => {
    setShow2(!show2);
  };
  const handlePlusToggle3 = () => {
    setShow3(!show3);
  };
  return (
    <>
      <div className="allfaqs">
        <div className="container">
          <div className="row gx-0" data-masonry='{"percentPosition": true }'>
            <div className="super-card1 mx-2 my-3 custom-bg-1">
              <Fade>
                <h3
                  className={show ? "fs-1 d-none" : "fs-1 d-block"}
                  id="question"
                >
                  Do you have a girlfriend?
                </h3>
                <h3
                  className={show ? "fs-4 d-block" : "fs-4 d-none"}
                  id="answer"
                >
                  To be honest I've a girlfriend and her name is{" "}
                  <span className="yellow-text">Bristy.</span>
                </h3>
              </Fade>
              <div className="plus">
                <button onClick={handlePlusToggle} className="supercard-plus">
                  <AiFillPlusCircle />
                </button>
              </div>
            </div>
            <div className="super-card2 mx-2 my-3 custom-bg-2">
              <Fade>
                <h3
                  className={show2 ? "fs-1 d-none" : "fs-1 d-block"}
                  id="question"
                >
                  I have a lot of questions. Can you answer me with no anger?
                </h3>
                <h3
                  className={show2 ? "fs-4 d-block" : "fs-4 d-none"}
                  id="answer"
                >
                  Never, but you can ask or talk to me as much as you want. I
                  like to talk a lot
                </h3>
              </Fade>
              <div className="plus">
                <button onClick={handlePlusToggle2} className="supercard-plus">
                  <AiFillPlusCircle />
                </button>
              </div>
            </div>
            <div className="super-card3 mx-2 my-3 custom-bg-3">
              <Fade>
                <h3
                  className={show3 ? "fs-1 d-none" : "fs-1 d-block"}
                  id="question"
                >
                  You are new to me, so how can I trust you and how much is your qualification in these jobs 
                </h3>
                <h3
                  className={show3 ? "fs-4 d-block" : "fs-4 d-none"}
                  id="answer"
                >
                  I've done a lot of projects with local clients before and I'm a certified developer so you can trust me
                </h3>
              </Fade>
              <div className="plus">
                <button onClick={handlePlusToggle3} className="supercard-plus">
                  <AiFillPlusCircle />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllFAQs;
